/* Campaign pages use a static hero, so announce readiness for the shared header
   and region selector after the browser has laid out the page. */
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('campaign-page')) return;
  var scheduled = false;
  function updateHeaderContrast() {
    scheduled = false;
    var hero = document.querySelector('.campaign-hero');
    var footer = document.querySelector('.footer-parent');
    var sampleY = 40;
    var overHero = hero && hero.getBoundingClientRect().bottom > sampleY;
    var overFooter = footer && footer.getBoundingClientRect().top <= sampleY;
    document.body.classList.toggle('campaign-over-dark', Boolean(overHero || overFooter));
  }
  function scheduleContrastUpdate() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateHeaderContrast);
  }
  updateHeaderContrast();
  window.addEventListener('scroll', scheduleContrastUpdate, { passive: true });
  window.addEventListener('resize', scheduleContrastUpdate, { passive: true });
  document.addEventListener('shopify:section:load', scheduleContrastUpdate);
  document.addEventListener('shopify:section:unload', scheduleContrastUpdate);
  document.addEventListener('shopify:section:reorder', scheduleContrastUpdate);
  if (window.jQuery) window.jQuery(window).trigger('heroReady');
});
